import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { App } from './routes/app';
import { history, store } from './store';
import './_style/app.scss';

const target = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App/>
    </ConnectedRouter>
  </Provider>,
  target
);
registerServiceWorker();
